import React from 'react';
import { func, string, arrayOf, shape, bool } from 'prop-types';
import { connect } from 'react-redux';

import locationShape from 'propTypes/locationShape';
import coord from 'propTypes/coord';

import { operations as mapOperations } from 'state/ducks/map';
import { operations as routeCreationOperations } from 'state/ducks/routeCreation';

import addObjectPriority from 'helpers/addObjectPriority';

import Segment from '../Segment';

const noop = _ => _;

export function SegmentGroup({
  segments,
  selectSegment,
  deselectSegment,
  enterEntity,
  leaveEntity,
  currentHover,
  lastSelectedSegment,
  disableInteraction,
}) {
  // eslint-disable-next-line global-require
  const SortingFeatureGroup = require('components/Map/MapComponents/SortingFeatureGroup').default;
  const hoveredId = currentHover && currentHover.id;

  const sortedSegmentsWithStateAndPriority = segments
    .map(segment => addObjectPriority(segment, hoveredId))
    .sort((segmentA, segmentB) => segmentA.priority - segmentB.priority);

  return (
    <SortingFeatureGroup>
      {sortedSegmentsWithStateAndPriority.map(segment => {
        const { id: segmentId, priority, isSelected, isAvailable } = segment;

        const selectHandler =
          lastSelectedSegment === segmentId
            ? () => deselectSegment(segmentId)
            : isAvailable ? () => selectSegment(segmentId) : noop;

        return (
          <Segment
            key={`segment-${segmentId}${isSelected && '-selected'}${isAvailable && '-available'}`}
            priority={segment.isSelected ? 15 : priority}
            segment={segment}
            isActive={isSelected || segmentId === hoveredId}
            isSelected={isSelected}
            onSelect={disableInteraction ? noop : selectHandler}
            onEnter={
              disableInteraction
                ? noop
                : () =>
                    enterEntity({
                      id: segmentId,
                      type: 'segment',
                    })
            }
            onLeave={
              disableInteraction
                ? noop
                : () =>
                    leaveEntity({
                      id: segmentId,
                      type: 'segment',
                    })
            }
          />
        );
      })}
    </SortingFeatureGroup>
  );
}

SegmentGroup.propTypes = {
  segments: arrayOf(
    shape({
      id: string,
      path: arrayOf(coord),
      from: locationShape,
      to: locationShape,
    })
  ).isRequired,
  selectSegment: func.isRequired,
  deselectSegment: func.isRequired,
  enterEntity: func.isRequired,
  leaveEntity: func.isRequired,
  currentHover: shape({
    id: string.isRequired,
  }),
  lastSelectedSegment: string,
  disableInteraction: bool.isRequired,
};

const mapStateToProps = ({ map }) => ({
  currentHover: map.currentHover,
});

export default connect(mapStateToProps, {
  ...mapOperations,
  ...routeCreationOperations,
})(SegmentGroup);



// WEBPACK FOOTER //
// ./src/components/Map/CreateRoute/SegmentGroup/index.js